import React, { useState, useEffect } from 'react';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import WeatherPage from './components/WeatherPage';
import modeIcon from './assets/mode-icon.svg';
import './index.css';

export default function App() {
  const [darkMode, setDarkMode] = useState(false);
  const client = new ApolloClient({
    cache: new InMemoryCache(),
    uri: 'https://graphql-weather-api.herokuapp.com/',
  });

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <ApolloProvider client={client}>
      <div className='darkMode'>
        <button
          className='dark-mode-toggle'
          onClick={() => {
            setDarkMode(!darkMode);
          }}
        >
          <div className='dark-mode-slider'>
            <img src={modeIcon} alt='dark mode toggler' />
          </div>
        </button>
      </div>
      <WeatherPage className='App' />
    </ApolloProvider>
  );
}
